import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import get from 'lodash/get';
import { AvatarLarge } from '../../../../components';
import { getLatestListings, limitText } from './utils';

import NewsLink from '../../../../components/NewsLink/NewsLink';
import NewsImage from '../../../../components/NewsImage/NewsImage';

import css from './NewsSearchSection.module.scss';

const Swiper =
  typeof window !== 'undefined'
    ? require('swiper/react').Swiper
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const SwiperSlide =
  typeof window !== 'undefined'
    ? require('swiper/react').SwiperSlide
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const Navigation =
  typeof window !== 'undefined'
    ? require('swiper').Navigation
    : dynamic(() => import('swiper'), {
      ssr: false,
    });

function NewsSearchSection(props) {
  const { searchedCategory } = props;
  const [news, setNews] = useState([]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      require('swiper/css');
      require('swiper/css/bundle');
      require('swiper/css/navigation');
    }

    getLatestListings({
      pub_listingType: 'provider',
      pub_hasAnyNews: true,
      sort: 'pub_latesNewsAddedDate'
    })
      .then(resp => {
        const container = [];
        resp.forEach(l => {
          const news = l?.attributes?.publicData?.news;
          const targetNews =
            !!news?.length && news?.filter(
              n => n && n?.title && n?.description && n?.image
            ) || [];
          targetNews
            .filter(n => {
              if (searchedCategory) {
                return n?.category === searchedCategory;
              } else {
                return true;
              }
            })
            .forEach(n => {
              n.author = l.author;
              return container.push(n)
            });
        });

        setNews(container);
      })
      .catch(e => console.log(e));
  }, [searchedCategory]);

  const screenWidth = typeof window !== 'undefined' && window.innerWidth;
  const slidesToShow = screenWidth && screenWidth < 768 ? 1.3 : 3;

  // Panel width relative to the viewport
  const panelMediumWidth = 50;
  const panelLargeWidth = 62.5;
  const cardRenderSizes = [
    '(max-width: 767px) 100vw',
    `(max-width: 1023px) ${panelMediumWidth}vw`,
    `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
    `${panelLargeWidth / 3}vw`,
  ].join(', ');

  return news && news.length > 0 ? (
    <div className={css.sectionContent}>
      <h2 className={css.sectionTitle}>News</h2>

      <Swiper
        modules={[Navigation]}
        navigation={{
          nextEl: '.custom_next',
          prevEl: '.custom_prev',
        }}
        spaceBetween={10}
        slidesPerView={slidesToShow}
        onSwiper={swiper => { }}
        onSlideChange={() => { }}
      >
        <div className="custom_next">
          {' '}
          {/* we need to add our own arrows, SwiperJs doesn't show default ones  */}
          <ArrowForwardIosIcon style={{ fontSize: '40px' }} />
        </div>
        <div className="custom_prev">
          <ArrowBackIosNewIcon style={{ fontSize: '40px' }} />
        </div>
        {news.map((n, index) => {
          const title = get(n, 'title', '');
          const link = get(n, 'link', null);
          const imgUrl = get(n, 'image.url', null);

          return (
            <SwiperSlide key={index.toString()}>
              <div className={css.newsItem}>
                {link ? (
                  <NewsLink
                    className={css.title}
                    link={link}
                  >
                    {title}
                  </NewsLink>
                ) : (
                  <span className={css.title}>{title}</span>
                )}
                <NewsImage
                  imgUrl={imgUrl}
                  link={link}
                  imageClassName={css.image}
                  iconClassName={css.newsIcon}
                />
                <p className={css.description}>{limitText(n?.description, 100)}</p>
                <div className={css.authorInfo}>
                  <AvatarLarge className={css.authorAvatar} user={n?.author} isRectangleVariants />
                  <h3 className={css.authorName}>{n?.author?.attributes?.profile?.displayName}</h3>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  ) : null;
}

export default NewsSearchSection;
